module.exports = __webpack_public_path__ + "static/media/ic_nearhit.554c627f.svg";